import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

export const NastavniMaterijaliDataTable = (props) => {
  const [nastavniMaterijali, setNastavniMaterijali] = useState();
  const [expandedRows, setExpandedRows] = useState([]);
  let ustanoveHashMap =  new Map([
    ["amcng.hr", "amc_nova_gradiska"],
    ["andragog", "andragog"],
    ["erudio.hr", "erudio"],
    ["uciliste-finis.com", "finis"],
    ["invictus.hr", "invictus"],
    ["izvorznanja.hr", "izvor_znanja"],
    ["libar", "libar"],
    ["uciliste-lovran.hr", "lovran"],
    ["nar-uciliste.hr", "nar"],
    ["pesg.hr", "pesg"],
    ["uciliste-piramida-znanja.hr", "piramida_z"],
    ["pou-knin.hr", "pou_knin"],
    ["profokus.hr", "profokus"],
    ["scp.hr", "scp"],
    ["ucilistesesvete.hr", "sesvete"],
    ["ssknezbranimir.hr", "sskb"],
    ["uciliste.net", "studium"],
    ["uciliste-virtus.hr", "virtus"],
    ["pouz.hr", "pouz"],
    ["zlatnavrata.hr", "zlatna_vrata"],
    ["test.hr", "uciliste"]
  ]);

  useEffect(() => {
    setNastavniMaterijali(props.data);
  }, [props.data]);

  const headerTemplate = (data) => {
    return (
      <React.Fragment>
        <span>{data.naziv_predmeta}</span>
      </React.Fragment>
    );
  };
  
  const nazivPredmeta = () => {
    return <></>;
  }

  const preuzmiDatoteku = ( datoteka ) => {
    return datoteka.url !== null 
        && datoteka.url !== undefined ? 
                        <Button
                          className={"pi"}
                          label="Preuzmi"
                          id={datoteka.url}
                          onClick={ () => { handlePreuzmiDatoteku(datoteka) }}
                        />
                      : 
                        <></>;
  }

  const handlePreuzmiDatoteku = ( datoteka ) => {
    /*console.log("Path: " + ustanoveHashMap.get(sessionStorage.getItem("ustanova")) +
    "/" +
    datoteka.id_predmeta +
    "/" +
    datoteka.naziv);*/
    fetch(process.env.REACT_APP_PREUZIMANJE_MATERIJALA_PATH +
      ustanoveHashMap.get(sessionStorage.getItem("ustanova")) +
        "/" +
        datoteka.id_predmeta +
        "/" +
        datoteka.naziv).then(response => {
      response.blob().then(blob => {
          const fileURL = window.URL.createObjectURL(blob); 
          let alink = document.createElement('a');
          alink.href = fileURL;
          alink.download = datoteka.naziv;
          alink.click();
      })
    })
  }
  
  return (
    <div className="centerText">
      <DataTable
        value={nastavniMaterijali}
        rowGroupMode="subheader"
        groupRowsBy="naziv_predmeta"
        responsiveLayout="scroll"
        expandableRowGroups
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowGroupHeaderTemplate={headerTemplate}
      >
        <Column
          header="Predmet"
          body={ nazivPredmeta }
          className="table-column-default"
        ></Column>
        <Column
          field="naziv"
          header="Naziv dokumenta"
          className="table-column-date"
        ></Column>
        <Column
          field="opis"
          header="Opis"
          className="table-column-course"
        ></Column>
        <Column
          field="url"
          body={ preuzmiDatoteku }
          header="Preuzimanje"
          className="table-column-grade"
        ></Column>
      </DataTable>
    </div>
  );
};

export default NastavniMaterijaliDataTable;
